<template>
  <div>
    <h6 class="c5"><i class="fa fa-question-circle"></i> Click and hold to sort items</h6>
    <draggable v-model="list">
    <transition-group>
      <div v-for="item in list" :key="item._id" class="sortable">
        <strong>{{item.name || '&nbsp;'}}</strong>
      </div>
    </transition-group>
  </draggable>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";

export default {
  name: "sheet-shared-sortable",
  props: ["section", "items", "disableAutoSave"],
  components: {
    draggable
  },
  computed: {
    list: {
      get() {
        return this.items;
      },
      set(value) {
        let payload = {
          section: this.section,
          items: value
        };
        this.$store.commit("characters/SORT_ITEMS", payload);
        if (!this.disableAutoSave) {
          this.autoSave();
        }
      }
    }
  },
  methods: {
    ...mapActions("characters", ["autoSave"])
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.sortable {
  cursor: grab;
  padding: 0.15em 0.25em 0;
  border: 1px $gray-400 solid;
  margin-bottom: 0.25em;
}
.sortable-chosen,
.sortable-ghost {
  cursor: grabbing;
  background-color: white;
}
</style>
